module.exports = __webpack_public_path__ + "static/media/logo-small.f7edbc6c.png";